import * as CookieConsent from 'vanilla-cookieconsent';

export const cookieConsentApi = {
  run: (config: CookieConsent.CookieConsentConfig) => CookieConsent.run(config),
  setLanguage: (languageCode: string, force?: boolean) => CookieConsent.setLanguage(languageCode, force),
  showPreferences: () => CookieConsent.showPreferences(),
  acceptedCategory: (categoryName: string) => CookieConsent.acceptedCategory(categoryName),
};
